// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"149":"bcd1e444","327":"02170ce2"}[chunkId] + ".chunk.css";
};